<template>
  <div class="col-sm-12 col-md-6 col-lg-4">
    <div class="element-wrapper">
      <h6 class="element-header">{{ t('profileUpdateProfile', 'profileUpdateProfile')}}</h6>
      <div class="element-box">
        <form id="formUpdateProfile" v-on:submit.prevent="updateProfileInfo">
          <h5 class="form-header"><i class="os-icon os-icon-cv-2"></i> {{ t('profileUpdateProfile', 'profileUpdateProfile')}}</h5>
          <hr>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label for="newUsername">{{ t('profileUpdateProfileUsernameLabel', 'profileUpdateProfileUsernameLabel') }}</label>
                <input id="newUsername" name="newUsername" v-model="newUsername" class="form-control" autocomplete="off" :placeholder="t('profileUpdateProfileUsernamePlaceholder', 'profileUpdateProfileUsernamePlaceholder')" type="text" aria-label="Username">
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="newName">{{ t('profileUpdateProfileNameLabel', 'profileUpdateProfileNameLabel') }}</label>
                <input id="newName" name="newName" v-model="newName" class="form-control" autocomplete="off" :placeholder="t('profileUpdateProfileNamePlaceholder', 'profileUpdateProfileNamePlaceholder')" type="text" aria-label="Full name">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label for="newTelephone">{{ t('profileUpdateProfileTelephoneLabel', 'profileUpdateProfileTelephoneLabel') }}</label>
                <input id="newTelephone" name="newTelephone" v-model="newTelephone" class="form-control" autocomplete="off" :placeholder="t('profileUpdateProfileTelephonePlaceholder', 'profileUpdateProfileTelephonePlaceholder')" type="text" aria-label="Telephone number">
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="newFax">{{ t('profileUpdateProfileFaxLabel', 'profileUpdateProfileFaxLabel') }}</label>
                <input id="newFax" name="newFax" v-model="newFax" class="form-control" autocomplete="off" :placeholder="t('profileUpdateProfileFaxPlaceholder', 'profileUpdateProfileFaxPlaceholder')" type="text" aria-label="Fax number">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label for="profilePass">* {{ t('profileUpdateProfilePasswordLabel', 'profileUpdateProfilePasswordLabel') }}</label>
                <input id="profilePass" name="profilePass" v-model="profilePass" class="form-control" :placeholder="t('profileUpdateProfilePasswordPlaceholder', 'profileUpdateProfilePasswordPlaceholder')" required="required" type="password">
              </div>
            </div>
          </div>
          <ResponseInfo v-if="getShowResponses.includes('showProfileInfoResponse')"/>
          <ValidationErrors v-if="getValidationErrors.validationName == 'UpdateProfileInfo'"></ValidationErrors>
          <div class="form-buttons-w"><button v-bind:class="{ disabled: !profilePass }" class="btn btn-primary" type="submit" value="submit">{{ t('profileUpdateButton', 'profileUpdateButton')}}</button></div>
        </form>
      </div>
    </div>
  </div> <!-- ENDOF Profile info change form -->
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'
import ValidationErrors from '@/components/ValidationErrors.vue'

export default {
  name: 'ProfileFormInfo',
  data() {
    return {
      newUsername: '',
      newName: '',
      newTelephone: '',
      newFax: '',
      profilePass: ''
    }
  },
  methods: {
    updateProfileInfo() {
      this.$store.dispatch('updateProfileInfo',{
        newUsername: this.newUsername,
        newName: this.newName,
        newTelephone: this.newTelephone,
        newFax: this.newFax,
        profilePass: this.profilePass
      })

      this.profilePass = ''
    }
  },
  computed: {
      ...mapGetters(['allTemplateDetails', 'getShowResponses', 'getValidationErrors'])
  },
  components: {
    ResponseInfo,
    ValidationErrors
  }
}
</script>

<style>
</style>
